<template>
  <div>
    <a-form :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" :form="form">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="浏览内容标题:">
            <a-input v-model="form.title" placeholder="请输入点赞内容标题" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="浏览用户">
            <a-input v-model="form.username" placeholder="输入/查询未知用户" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="浏览时间">
            <a-range-picker v-model="pickDate" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="内容类型">
            <a-select allowClear v-model="form.type" placeholder="请选择内容类型">
              <a-select-option v-for="item in READ_TYPE" :key="item.key" :value="item.key" :title="item.value">
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="浏览内容ID">
            <a-input v-model="form.map_id" placeholder="请输入浏览内容ID" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6" :offset="12">
          <div class="flex_end">
            <a-button type="primary" icon="search" @click="search" style="margin-right: 12px">查询</a-button>
            <a-button type="primary" icon="delete" ghost @click="resetCondition">重置</a-button>
          </div>
        </a-col>
      </a-row>
    </a-form>

    <a-table
      style="margin-top: 20px"
      bordered
      @change="pageChange"
      :pagination="pagination"
      :columns="columns"
      :data-source="dataSource"
      :loading="loading"
      rowKey="id"
    >
      <template slot="type" slot-scope="text"> {{ textFormat(text) }} </template>
      <template slot="name" slot-scope="text, scoped">
        {{ text }} <span v-show="parseInt(scoped.number)">({{ scoped.number }})</span>
      </template>
    </a-table>
  </div>
</template>

<script>
import { readRecordColumns } from './business/index'
import moment from 'moment'
import { mapState } from 'vuex'
import { readRecordList } from '@/api/groupWeb/article'

const ISearchFrom = () => {
  return {
    map_id: undefined, //  浏览内容ID
    created_time_end: undefined, //  浏览时间结束时间
    created_time_start: undefined, //  浏览时间开始时间
    title: undefined, //  浏览内容标题
    type: undefined, // 内容类型（1期刊  2文章）
    username: undefined //  浏览内容ID
  }
}

export default {
  name: 'ReadRecord',
  computed: {
    ...mapState(['label']),
    READ_TYPE() {
      const obj = this.label?.data?.READ?.TYPES || {}
      const types = Object.keys(obj).map(key => {
        return { key: parseInt(key), value: obj[key] }
      })
      return types
    }
  },
  watch: {
    pickDate: {
      handler(val) {
        this.form.created_time_start = val.length ? moment(val[0]).format('YYYY-MM-DD') : ''
        this.form.created_time_end = val.length ? moment(val[1]).format('YYYY-MM-DD') : ''
      },
      immediate: true
    },
    $route: {
      handler(route) {
        if (route.query?.id) {
          this.form.map_id = route.query.id
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      loading: false,
      columns: readRecordColumns,
      dataSource: [],
      pickDate: [],
      form: ISearchFrom(),
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showQuickJumper: true
      }
    }
  },
  methods: {
    pageChange(pagination) {
      this.pagination.current = pagination.current
      this.getList()
    },
    textFormat(text) {
      return this.READ_TYPE.find(item => item.key === Number(text))?.value
    },
    resetCondition() {
      this.pagination.current = 1
      this.pickDate = []
      this.form = ISearchFrom()
      this.getList()
    },
    search() {
      this.pagination.current = 1
      this.getList()
    },

    async getList() {
      const params = Object.assign({}, this.form, {
        page: this.pagination.current,
        per_page: this.pagination.pageSize
      })
      this.loading = true
      try {
        const { data } = await readRecordList(params)
        this.pagination.pageSize = data?.pagination?.per_page || 10
        this.pagination.current = data?.pagination?.page || 1
        this.pagination.total = data?.pagination?.total || 0
        this.dataSource = data?.list
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    this.getList()
  }
}
</script>

<style lang="less" scoped>
.flex_end {
  display: flex;
  justify-content: flex-end;
}
</style>
